import * as types from 'store/actions/types';

const INITIAL_STATE = {
	data: null,
	loading: true,
	error: false
};

export default function (state = INITIAL_STATE, action = {}) {
	switch (action.type) {
		case types.TV_SHOW_SEASON_LOADING:
			return INITIAL_STATE;

		case types.TV_SHOW_SEASON_SUCCESS:
			const { number: seasonNumber } = action.payload;
			const isSeasonZero = seasonNumber === 0;
			if (isSeasonZero) {
				action.payload.episodes.reverse();
			}
			return {
				data: action.payload,
				loading: false,
				error: false
			};
		case types.TV_SHOW_SEASON_ERROR:
			return {
				...state,
				loading: false,
				error: true
			};

		default:
			return state;
	}
}
